const validate = (values) => {
    const errors = {};
  
    if (!values.notes) {
      errors.notes= 'Please enter note'
    }
    if(!values.title) {
      errors.title= 'Please enter note title'
    }
    // if (!values.answerId3) {
    //   errors.answerId3= 'Please enter note'
    // }
    return errors;
  };
  export default validate;


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Notes/validate.js